/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */

window.PXUTheme.jsAjaxCart = {
 
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.showDrawer();
        window.PXUTheme.jsAjaxCart.addFreeProduct();
        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      $("body").addClass("ajax-overlly");
      const $addToCartForm = $(this).closest('form');
      window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      const lineItemId = $(this).data("cart-item_id");
      var freeVariantId ="";
      
      if( lineItemId == freeProductId ){
        freeVariantId = freeProductId;
      }else if( lineItemId == freeWaterProductId ){
        freeVariantId = freeWaterProductId
      }else{}
     
     
    // for free cart remove only
      if( lineItemId !="" && freeVariantId ){ //freeProductId assign on theme.liquid
        if( lineItemId == freeVariantId ){
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=0&id=' + lineItemId,
            dataType: 'json',
            success: function (cart) {
              checkFreeWaterId = false;
              checkFreeVariantId = false;
              window.PXUTheme.jsAjaxCart.updateView();              
            },
            error: function (XMLHttpRequest, textStatus) {
              var response = eval('(' + XMLHttpRequest.responseText + ')');
              response = response.description;
            }
          });
          
          return false;
        }
      }else{
        window.PXUTheme.jsAjaxCart.removeFromCart(lineID);
         if (window.PXUTheme.jsCart) {
          window.PXUTheme.jsCart.removeFromCart(lineID);
        }
  
        return false;
      }
    });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      $("body").removeClass("ajax-overlly");
      window.PXUTheme.jsAjaxCart.hideDrawer();
      window.PXUTheme.jsAjaxCart.hideMiniCart();
      
      return false;
    });

   $(document).on('click', '.js-upsell-add-to-cart', function(e){
     e.preventDefault();
     let variantId = $(this).closest(".product-info-block").find('[name="upsell_id"]').val();
     let qty = 1; 
     if( variantId ){
       $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
         data:{'quantity':qty, 'id':variantId},
         success: function (product) {          
           window.PXUTheme.jsAjaxCart.showDrawer();
           window.PXUTheme.jsAjaxCart.updateView();
           window.PXUTheme.jsAjaxCart.addFreeProduct();
         }
       }) 
     } 
   }) 
  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(window.PXUTheme.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
    $('body').addClass('body__overlay');
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
    $('body').removeClass('body__overlay');
  },
  removeFromCart: function (lineID, callback) {
    
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        
        // let cartTotal = parseInt( cart.total_price/100 );
        // let variantId = parseInt(freeProductId); //freeProductId assign on theme.liquid
        // let productFinalPrice = parseInt(freeProductPrice);

        // let freeWaterVariantId = parseInt(freeWaterProductId);
        // let freeWaterPrice = parseInt(freeWaterProductPrice);

        
        
        // if( freeWaterVariantId !="" && freeWaterPrice !="" ){
        //   variantId = freeWaterVariantId;
        //   productFinalPrice = freeWaterPrice;
        // }
        
        // if( variantId !="" && productFinalPrice !="" ){
        //   if( cartTotal < productFinalPrice ){
        //     $.ajax({
        //         type: 'POST',
        //         url: '/cart/change.js',
        //         data: 'quantity=0&id=' + variantId,
        //         dataType: 'json',
        //         success: function (cart) {
        //           window.PXUTheme.jsAjaxCart.updateView();
        //           return;
        //         },
        //         error: function (XMLHttpRequest, textStatus) {
        //           var response = eval('(' + XMLHttpRequest.responseText + ')');
        //           response = response.description;
        //         }
        //       });
        //      return false;
        //   }
        // }
        
       window.PXUTheme.jsAjaxCart.updateView();        
       window.PXUTheme.jsAjaxCart.addFreeProduct();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  initializeAjaxCart: function () {
    
    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {
        $('[data-ajax-cart-content]').html(html.content);  
        $(".cart-upsell-blocks").hide();
        
        const elementPrice = $(html.content).find('.js-position-price');
        const cartTotal = elementPrice.data("cart_total");
        const positionPriceA = elementPrice.data("position_1");
        const positionPriceB = elementPrice.data("position_2");
        const positionPriceC = elementPrice.data("position_3");
        

        $(".position-act").removeClass("active");
        if( cartTotal < positionPriceA ){
          $(".msg-position-1").addClass("active");
        }else if( cartTotal < positionPriceB ){
          $(".msg-position-2").addClass("active");
        }else if( cartTotal < positionPriceC ){
          $(".msg-position-3").addClass("active");
        }else{
          $(".msg-position-4").addClass("active");
        }
        
        if( $(html.content).find(".upsell-product").length > 0 ){
          $(".cart-upsell-blocks").show();
        }
        $('.upsell-slider').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: false
              }
            }
          ]
        });
        
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);

      })
      .fail(() => {
        // some error handling
      });
  },
  addToCart: function ($addToCartForm) {
    
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');

    if (this.recipientForm) {
      this.recipientForm.classList.remove('recipient-form--has-errors');
    }

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function (product) {          
          let $el = $('[data-ajax-cart-trigger]');
          
          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          function addedToCart() {

            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              window.PXUTheme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }

            $el.addClass('show-mini-cart');

            $addToCartBtn.find('span')
              .removeClass('fadeInDown');
          }

          window.setTimeout(function () {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.checkmark')
              .removeClass('checkmark-active');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');

            $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

          }, 1000);

          window.PXUTheme.jsAjaxCart.showDrawer();
          window.PXUTheme.jsAjaxCart.updateView();
          window.PXUTheme.jsAjaxCart.addFreeProduct();
          
          if (window.PXUTheme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }
          //window.PXUTheme.jsAjaxCart.addFreeProduct();
        },
        error: XMLHttpRequest => {
          const response = eval('(' + XMLHttpRequest.responseText + ')');

          $('.warning').remove();

          let cartWarning;

          if (response.errors && response.errors.email) {
            this.recipientForm.classList.add('recipient-form--has-errors');
          } else {
            cartWarning = `<p class="cart-warning__message animated bounceIn">${response.description.replace('All 1 ', 'All ')}</p>`;
          }

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    }
  },
  updateView: function () {
    
    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {

      if (options.item_count > 0) {
        const cartDetails = $(html.content).find('.cart-details-wrapper'); 
        const itemList = $(html.content).find('.ajax-cart__list');
        const elementPrice = $(html.content).find('.js-position-price');
        const cartTotal = elementPrice.data("cart_total");
        const positionPriceA = elementPrice.data("position_1");
        const positionPriceB = elementPrice.data("position_2");
        const positionPriceC = elementPrice.data("position_3");        
        
        elementPrice.data("cart_total");
        $('.ajax-cart__list').replaceWith(itemList);
        $('.cart-details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
        $(".cart-upsell-blocks").hide();

        $(".position-act").removeClass("active");
        if( cartTotal < positionPriceA ){
          $(".msg-position-1").addClass("active");
        }else if( cartTotal < positionPriceB ){
          $(".msg-position-2").addClass("active");
        }else if( cartTotal < positionPriceC ){
          $(".msg-position-3").addClass("active");
        }else{
          $(".msg-position-4").addClass("active");
        }
      
        if( $(html.content).find(".upsell-product").length > 0 ){
          $(".cart-upsell-blocks").show();
        }
        
        $('.upsell-slider').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: false
              }
            }
          ]
        }); 
      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
        $('.show_progress_bar').css('width','0px');
        var data_price = $('.progress_bar_heading').attr('data-price');
        $('.progress_bar_heading').text('You’re '+data_price+' away from free shipping!');
      }

      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      } 
      
    })
    .fail(() => {
      // some error handling
    });
  },
  addFreeProduct: function(){
    var checkFiberPowder = false;
    let qty = 1;
    let cartTotal;
    
    $.getJSON("/cart.js", function(cart) {
      cartTotal = parseInt( cart.total_price/100 );
      let variantId = parseInt(freeProductId); //freeProductId assign on theme.liquid
      let productFinalPrice = parseInt(freeProductPrice);
      
      //Free water bottle data
      let waterBottleVId = parseInt(freeWaterProductId); //freeWaterProductId assign on theme.liquid
      let waterBottlePrice = parseInt(freeWaterProductPrice);
      var checkFreeVariantId = false;
      var checkFreeWaterId = false;
      
      $.each(cart.items, function(index, item) {
        if( item.id == variantId ){
          checkFreeVariantId = true;
        }
        if( item.id == waterBottleVId ){
          checkFreeWaterId = true;
        }
        if( item.product_id == "7337424781500" ){
          checkFiberPowder = true;
        }        
      });

      // if( variantId !="" && productFinalPrice !="" ){
      //   setTimeout(function(){
      //     addFreeGift(variantId, productFinalPrice, checkFreeVariantId);
      //   },600);
      // }

      // if( waterBottleVId !="" && waterBottlePrice !="" ){
      //   setTimeout(function(){ 
      //     addFreewaterGift(waterBottleVId, waterBottlePrice, checkFreeWaterId);  
      //   },400);
      // }

      addFreeGift(variantId, productFinalPrice, checkFreeVariantId, function() {
        addFreewaterGift(waterBottleVId, waterBottlePrice, checkFreeWaterId);
      });

      //addFreeGift(43712569639100, 120, checkFreeWaterId); 
            
      if (cart.total_price === 0 && cart.items.length > 0) {
        fetch('/cart/clear.js', { method: 'POST' })
        .then(() => {
          console.log('Cart cleared.');
          window.location.href="https://www.trybonny.com"
        })
        .catch(error => console.error('Error clearing cart:', error));
      }
    }); 

    function addFreeGift(variantId, productFinalPrice, checkFreeVariantId, callback){
      if( variantId !="" && productFinalPrice !="" ){
        if( cartTotal >= productFinalPrice && checkFiberPowder ){
          if( !checkFreeVariantId ){
            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data:{'quantity':qty, 'id':variantId},
              success: function (product) {
                window.PXUTheme.jsAjaxCart.updateView();
                if (typeof callback === "function") callback();
              }
            })
          }else{
            if (typeof callback === "function") callback();
          }
        }else{
          if( variantId && cartTotal < productFinalPrice || variantId && !checkFiberPowder ){
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: 'quantity=0&id=' + variantId,
              dataType: 'json',
              success: function (cart) {
                checkFreeVariantId = false;
                checkFreeWaterId = false;
                window.PXUTheme.jsAjaxCart.updateView();
                if (typeof callback === "function") callback();
              },
              error: function (XMLHttpRequest, textStatus) {
                var response = eval('(' + XMLHttpRequest.responseText + ')');
                response = response.description;
                if (typeof callback === "function") callback();
              }
            });
          }
        }
      }else{
        if (typeof callback === "function") callback();
      }
    }
    
    function addFreewaterGift(variantId, productFinalPrice, checkFreeVariantId){
      if( variantId !="" && productFinalPrice !="" ){
        if( cartTotal >= productFinalPrice ){
          if( !checkFreeVariantId ){
            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data:{'quantity':qty, 'id':variantId},
              success: function (product) {
                window.PXUTheme.jsAjaxCart.updateView();
              }
            })
          }
        }else{
          if( variantId && cartTotal < productFinalPrice){
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: 'quantity=0&id=' + variantId,
              dataType: 'json',
              success: function (cart) {
                checkFreeVariantId = false;
                checkFreeWaterId = false;
                window.PXUTheme.jsAjaxCart.updateView();
              },
              error: function (XMLHttpRequest, textStatus) {
                var response = eval('(' + XMLHttpRequest.responseText + ')');
                response = response.description;
              }
            });
          }
        }
      }
    }
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    // $('.ajax-submit').off();
    // $('[data-ajax-cart-delete]').off();
    // $('.js-upsell-add-to-cart').off();
  }
}

/******/ })()
;